<template>
    <div class="content">

        <section>

            <div class="modal" :class="isActive(modalShow)">
                <div class="modal-background"></div>
                <div class="modal-content">
                    <p class="image is-4by4">
                        <img :src="modalImg" alt="">
                    </p>
                </div>
                <button class="modal-close is-large" @click="modalShow = !modalShow" aria-label="close"></button>
            </div>

        </section>
        <section class="section wow fadeIn" v-for="item in products">
            <div class="container">
                <div class="columns">
                    <div class="column is-2">

                    </div>
                    <div class="column is-6">

                        <h2 class="title" v-html="item.title"></h2>
                        <p class="description" v-html="item.description"></p>
                        <p class="extraData">
                            <strong v-html="item.extraData"></strong>
                        </p>

                    </div>
                    <div class="column is-3 box-img" @click="modalShow = true, modalImg = item.image">
                        <img :src="item.image" alt="">
                    </div>
                    <div class="column is-2">

                    </div>
                    

                </div>
                <div  v-if="item.component && item.component.name === dataTable">
                   
                    <data-table :type="item.component.type"></data-table>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import WOW from "wowjs";
import "wowjs/css/libs/animate.css";
import dataTable from "./../products-components/dataTable";
export default {
  name: "products",
  data() {
    return {
      modalShow: false,
      modalImg: null,
      dataTable: "data-table"
    };
  },
  components: {
    dataTable
  },
  props: {
    products: {
      type: Array
    }
  },
  methods: {
    isActive: flag => {
      if (flag) {
        return "is-active";
      }
    }
  },
  mounted() {
    const lib = WOW.WOW;
    const Wow = new lib();
    Wow.init();
  }
};
</script>
<style lang="scss" scoped>
$green: #7cb542;
.content {
  position: relative;
}

.modal {
  z-index: 9999;
}
.box-img {
  cursor: pointer;
}

.title {
  color: $green;
  font-family: "Montserrat";
  font-size: 1.7rem;
  margin-bottom: 20px;
}

.description {
  margin-bottom: 20px;
}
</style>





// WEBPACK FOOTER //
// src/components/categories/products.vue